import { PageHeader } from "@shared/components/PageHeader";
import { Stepper } from "@shared/components/Stepper";
import { useToast } from "@shared/hooks/use-toast";
import { Button } from "@shared/ui/button";
import { ArrowLeft } from "lucide-react";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ApplicationDetailLanding } from "./applicationDetails/applicationDetailLanding";
import { ApplicationReviewLanding } from "./applicationReview/applicationReviewLanding";

const NewConnectionLanding: React.FC = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const { consumerId } = useParams();

  const isEditMode = Boolean(consumerId);

  useEffect(() => {
    if (!isEditMode) {
      localStorage.removeItem("stepper-progress");
      localStorage.removeItem("consumerFirstStepData");
      if (window.location.hash) {
        window.location.hash = "";
      }
    }
  }, [isEditMode]);

  const handleComplete = async (allStepData: any) => {
    toast({
      title: "Application Submitted Successfully",
    });

    navigate("/cx/consumer-management/create");
  };

  const stepperSteps = [
    {
      id: "application-details",
      title: "Application Details & Documents",
      component: <ApplicationDetailLanding />,
      slug: "application-details",
    },
    {
      id: "application-review",
      title: "Application Review",
      component: <ApplicationReviewLanding />,
      slug: "application-review",
    },
  ];

  return (
    <div className="w-full space-y-6">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate("/cx/consumer-onboarding")}
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>

        <PageHeader
          title="New Connection"
          subtitle="Create a new connection application"
        />
      </div>

      <Stepper
        key={isEditMode ? `edit-${consumerId}` : "new-consumer-form"}
        steps={stepperSteps}
        onComplete={handleComplete}
        persistProgress={isEditMode}
        enableRouting={isEditMode}
      />
    </div>
  );
};

export default NewConnectionLanding;
